import React, { Component } from 'react';
import { Menu, Dropdown, Icon, Avatar, Badge, Input, Button } from 'antd';
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import i18n from '../../../constants/initLng';
import * as Config from '../../../constants/Define'
import history from '../../../helpers/history';
import { PATHS } from './../../../constants/Define';
import { isMobile } from 'react-device-detect';
import BreadcrumbComponent from "../common/BreadcrumbComponent";
import DEFINE from './../../../constants/Define';
// const menu = (
//     <Menu>
//         <Menu.Item>
//             <button rel="noopener noreferrer" onClick={}>
//                 { i18n.t(`logout`) }
//             </button>
//         </Menu.Item>
//     </Menu>
// );

class Header extends Component {

    toggleCollapsedMenuLeft = () => {
        this.props.toggleCollapsedMenuLeft(this.props.collapsedMenuLeft)
    };

    onLogoutRequest = () => {
        if (confirm(this.props.t('notification.sureLogout'))) { //eslint-disable-line
            this.props.onLogoutRequest();
        }
    };

    onPressChangePassword = () => {
        this.props.history.push(PATHS.PROFILE.path)
    }


    menu = () => (
        <Menu>
            <Menu.Item>
                <a rel="noopener noreferrer" onClick={this.onPressChangePassword}>
                    <Icon type={'lock'} style={{ fontSize: '14px', marginRight: 10 }} />{i18n.t(`item.user.changePassword`)}
                </a>
            </Menu.Item>
            <Menu.Item>
                <a rel="noopener noreferrer" onClick={this.onLogoutRequest}>
                    <Icon type={'logout'} style={{ fontSize: '14px', marginRight: 10 }} />{i18n.t(`logout`)}
                </a>
            </Menu.Item>
        </Menu>
    );

    render() {
        const { t, dataUser, match, collapsedMenuLeft, withAvatar, transparent } = this.props;
        return (
            <div className={`row hms-header ${!transparent ? 'border-bottom' : ''}`} style={{minHeight: 55}}>
                <nav className={`navbar navbar-static-top ${isMobile ? 'pl-4' : 'pl-3'}`} role="navigation"
                    style={{ marginBottom: 0, display: 'flex', flexDirection: 'row', backgroundColor: transparent ? 'transparent' : undefined }}>
                    {(isMobile) &&
                        <div className="navbar-header" style={{ paddingTop: '10px' }}>
                            <Icon type={collapsedMenuLeft ? 'menu-unfold' : 'menu-fold'}
                                onClick={this.toggleCollapsedMenuLeft} style={{ fontSize: '25px' }} />
                        </div>
                    }
                    <div className="breadcrumb-placeholder"></div>
                    {withAvatar &&
                        <ul className="nav navbar-top-links navbar-right">
                            <li style={{ marginRight: isMobile && '15px' }}>
                                <Dropdown overlay={this.menu} className={`cursorPointer align-items-center ${!isMobile && 'mr-3'}`}
                                    style={{ verticalAlign: 'middle', marginBottom: '0' }}>
                                    <p className="mb-0">
                                        <Avatar size="large"
                                            src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${dataUser.avatarUrl ? dataUser.avatarUrl : "static-voucher.vinpearl.com/images/logo.png"}`}
                                            className={`mr-2`} />
                                        {!isMobile &&
                                            dataUser.fullname
                                        }
                                        {!isMobile && <Icon type="down" className={`ml-1`} />}
                                    </p>
                                </Dropdown>
                            </li>
                        </ul>
                    }
                </nav>
            </div>
        );
    }

}

export default withRouter(withTranslation()(Header));